import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TaskView from '../b2ai-tasks/acoustic-tasks/common/TaskView';
import { AcousticTask } from '../b2ai-tasks/acoustic-tasks/common/models';
import { AudioCheckDefinition } from '../b2ai-tasks/acoustic-tasks/generic';


export const CheckPage = () => {
  const navigate = useNavigate();

  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...AudioCheckDefinition,
    id: 'test',
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: [
      {
        id: 'audio-check-1',
        name: 'Audio Check-1',
        title: "",
        instructions: `Click on the Record button below and say something out loud like “Testing 1, 2, 3”. Recording will stop automatically after 5 seconds. Click Play to hear your recording. If you hear background noise, please go to a quieter place and try again by selecting Redo Recording. If it sounds good, continue.`,
        profileName: 'speech',
        stopwatchSeconds: 5,

      }
    ]

  }));

  const handleOnCompletion = () => {
    console.log("Audio Check completed");
    navigate('/');
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        showGainSlider
        showAudioBar
      />
    </div>
  );
}
